module.exports = __webpack_public_path__ + "img/badger-honey.684f61cd.svg";